import { CSSObject } from '@chakra-ui/react';
import { TBodyTextProps } from '../types';

export const BodyText = ({ heading }: TBodyTextProps): CSSObject => ({
  fontWeight: heading ? 'medium' : 'normal',
  fontSize: heading ? 'sm' : 'xs',
});

export const RadioText: CSSObject = {
  fontSize: 'xs',
  mb: '2',
};

export const RadioLimitChoice: CSSObject = {
  mb: '2',
  bg: 'gray.200',
  border: 'none',
  '&[data-checked], &[data-checked]:hover': {
    bg: 'delta.600',
    borderWidth: '7px',
    borderStyle: 'solid',
    borderColor: 'gray.200',
    color: 'delta.600',
  },
};

export const ButtonSubmit: CSSObject = {
  color: 'white',
};

export const DepositLimitContainer: CSSObject = {
  mt: '4',
  border: '1px dashed',
  borderColor: 'gray.300',
  borderRadius: 'base',
  p: '4',

  '.chakra-input__left-addon': {
    bg: 'gray.50',
    fontSize: 'xs',
    border: '1px solid',
    borderColor: 'gray.300',
    borderRight: 'none',
    h: '9',
    color: 'gray.700',
  },
  '.chakra-select': {
    bg: 'gray.50',
    border: '1px',
    borderColor: 'gray.300',
    fontSize: 'xs',
    borderRadius: 'lg',
    h: '9',
    color: 'gray.400',
    fontWeight: 'sm',
  },
  '#limitAmount-input': {
    fontSize: 'xs',
    borderRightRadius: 'base',
    bg: 'gray.50',
    border: '1px solid',
    borderColor: 'gray.300',
    color: 'gray.700',
    h: '9',
    '.chakra-form__error-message': {
      color: 'white',
    },
    _hover: {
      bg: 'gray.100',
      borderWidth: '1px',
      borderStyle: ' solid',
      borderColor: 'gray.400',
    },
    _focus: {
      borderWidth: '2px',
      borderStyle: ' solid',
      borderColor: 'blue.300',
      boxShadow: '0px 2px 8px 0px rgba(66, 153, 225, 0.45)',
    },
  },
};
